import React from "react";

import { Select, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import CustomCssTransition from "../../../components/UI/CustomCssTransition/customCssTransition";
import "../CustomUrl.css";

const FieldLabel = ({ children, tooltip }) => (
  <label className="custom-url-field-label">
    {children}
    {tooltip && (
      <Tooltip title={tooltip}>
        <InfoCircleOutlined style={{ cursor: "pointer" }} />
      </Tooltip>
    )}
  </label>
);

const Step1Panel = ({
  serviceTitanBusinessUnits,
  serviceTitanJobs,
  serviceTitanJobTags,
  tagIds,
  setTagIds,
  selectedBu,
  setSelectedBu,
  selectedJobType,
  setSelectedJobType,
  CampaignList,
  setSelectedCampaign,
  filterOption,
  selectedCampaign,
  provider = "ST",
  urlMode = "campaign_tracking",
}) => {
  const isHCP = provider === "HCP";
  const isJobBooking = urlMode === "job_booking";

  return (
    <div>
      {/* Job fields - ONLY in Job Booking mode */}
      <CustomCssTransition
        in={isJobBooking && !isHCP}
        timeout={300}
        classNames="glimpse"
        unmountOnExit
      >
        <div className="custom-url-field-group">
          <FieldLabel>
            Business Unit
          </FieldLabel>
          <Select
            showSearch
            allowClear
            filterOption={filterOption}
            placeholder="Select Business Unit"
            value={selectedBu?.id ?? undefined}
            onChange={(value) => {
              if (value == null) setSelectedBu(null);
              else setSelectedBu(serviceTitanBusinessUnits?.find((e) => e.id === value));
            }}
            options={(serviceTitanBusinessUnits || []).map((bu) => ({
              label: bu.name ?? String(bu.id),
              value: bu.id,
            }))}
            style={{ width: "100%", borderRadius: "8px" }}
          />
        </div>
      </CustomCssTransition>

      <CustomCssTransition
        in={isJobBooking}
        timeout={300}
        classNames="glimpse"
        unmountOnExit
      >
        <div className="custom-url-field-group">
          <FieldLabel tooltip="The service type customers will book when using this link.">
            Job Type
          </FieldLabel>
          <Select
            showSearch
            placeholder="Select Job Type"
            value={selectedJobType?.id ?? undefined}
            filterOption={filterOption}
            onChange={(value) => {
              const job = value ? serviceTitanJobs?.find((e) => e.id === value) : null;
              setSelectedJobType(job);
            }}
            options={(serviceTitanJobs || []).map((job) => ({
              label: job.name ?? String(job.id),
              value: job.id,
            }))}
            style={{ width: "100%", borderRadius: "8px" }}
          />
        </div>
      </CustomCssTransition>

      {/* ServiceTitan Campaign - shown in BOTH modes */}
      <div className="custom-url-field-group">
        <FieldLabel>
          ServiceTitan Campaign
        </FieldLabel>
        <Select
          style={{ width: "100%", borderRadius: "8px" }}
          allowClear
          placeholder="Select ServiceTitan Campaign"
          value={selectedCampaign?.id ?? undefined}
          onChange={(value) => {
            if (!value) {
              setSelectedCampaign(null);
              return;
            }
            const campaign = CampaignList.find((e) => e.value === value);
            setSelectedCampaign(campaign ? { id: campaign.value, name: campaign.label } : null);
          }}
          filterOption={filterOption}
          showSearch
          options={(CampaignList || []).map((c) => ({
            label: c.label,
            value: c.value,
          }))}
        />
      </div>

      <div className="custom-url-field-group">
        <FieldLabel>
          Job Tags
        </FieldLabel>
        <Select
          showSearch
          filterOption={filterOption}
          mode="multiple"
          placeholder="Select Job Tags"
          style={{ width: "100%", padding: "5px", borderRadius: "8px" }}
          options={
            serviceTitanJobTags?.data
              ? serviceTitanJobTags.data.map((item) => ({
                  label: item.name,
                  value: isHCP ? item.name : item.id,
                  desc: item.name,
                }))
              : []
          }
          defaultValue={
            serviceTitanJobTags?.data
              ? serviceTitanJobTags.data
                  .filter((item) => 
                    isHCP 
                      ? tagIds?.includes(item.name)
                      : tagIds?.includes(item.id)
                  )
                  .map((data) => 
                    isHCP ? data.name : data.id
                  ) ?? []
              : []
          }
          value={
            serviceTitanJobTags?.data
              ? serviceTitanJobTags.data
                  .filter((item) => 
                    isHCP 
                      ? tagIds?.includes(item.name)
                      : tagIds?.includes(item.id)
                  )
                  .map((data) => 
                    isHCP ? data.name : data.id
                  ) ?? []
              : []
          }
          onChange={(value) => {
            setTagIds([...value]);
          }}
          size="large"
        />
      </div>
    </div>
  );
};

export default Step1Panel;
